<template>
  <a-modal
    :title="model.id ? '编辑角色' : '新增角色'"
    okText="确定"
    :width="700"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <!-- form-model -->
    <a-form-model
      class="modal-form-model"
      ref="ruleForm"
      :model="model"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <!-- 角色名称 -->
      <a-form-model-item
        label="角色名称"
        prop="name"
        :rules="{ required: true, message: '请填写角色名称', trigger: 'blur' }"
      >
        <a-input v-model.trim="model.name" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>
      <!-- 页面权限 -->
      <a-form-model-item
        label="页面权限"
        prop="page"
        class="checkbox-form"
      >
        <a-checkbox-group v-model="model.page">
          <a-checkbox v-for="item in rolePermissionList.menu" :key="item.id" :value="item.id">{{ item.show_name }}</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <!-- 操作权限 -->
      <a-form-model-item
        label="操作权限"
        prop="page"
        class="checkbox-form"
      >
        <a-checkbox-group v-model="model.action">
          <a-checkbox v-for="item in rolePermissionList.operation" :key="item.id" :value="item.id">{{ item.show_name }}</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <!-- 数据权限 -->
      <a-form-model-item
        label="数据权限"
        prop="page"
      >
        <a-radio-group v-model="model.data">
          <a-radio v-for="item in rolePermissionList.data" :key="item.id" :value="item.id">{{ item.show_name }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getRolePermissionList, getRoleDetail, editRole } from '@/api/request'
export default {
  data () {
    return {
      // 显示/加载
      visible: false,
      confirmLoading: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      // 水平布局，保持一行
      span: 12,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      // 上传数据
      model: {},
      // 角色菜单权限
      rolePermissionList: []
    }
  },
  created () {
    this.initModel()
  },
  methods: {
    // 初始化数据 model
    initModel () {
      this.model = {
        //（可选）建议初始化，方便对应字段
        name: undefined,
        // 角色id
        id: undefined,
        // 页面权限
        page: [],
        // 操作权限
        action: [],
        // 数据权限
        data: undefined
      }
    },
    // 显示
    showModal (record) {
      // 显示
      this.visible = true
      // 获取角色权限菜单
      this.getRolePermissionList()
      // 编辑时
      if (record && record.id) {
        this.model.id = record.id
      }
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        // 重置表单
        this.$refs['ruleForm'].resetFields()
        // 初始化数据
        this.initModel()
        this.visible = false
      }
    },
    // 重新指定渲染控件
    getPopupContainer (triggerNode) {
      return triggerNode.parentNode
    },
    // 获取角色详情
    getRoleDetail () {
      this.confirmLoading = true
      getRoleDetail({
        id: this.model.id
      }).then(res => {
        this.confirmLoading = false
        const { code, data, msg } = res
        if (code === 0) {
          // 名称
          this.model.name = data.show_name
          // 三个权限所有id的集合
          const rolePermissionList = this.rolePermissionList
          let allPermissionIds = {
            pageIds: rolePermissionList.menu.map(item => item.id),
            actionIds: rolePermissionList.operation.map(item => item.id),
            dataIds: rolePermissionList.data.map(item => item.id)
          }
          // 权限类型
          let types = ['page', 'action', 'data']
          // 选中的权限按照类型存放
          let permission = {}
          // 将后端返回的 data.permissions 按照权限类型拆分
          types.forEach(type => {
            data.permissions.forEach(id => {
              if ((allPermissionIds[`${type}Ids`]).includes(id)) {
                if ( type == 'data') {
                  // 单选
                  permission[type] = id
                } else {
                  // 多选
                  permission[type] = (permission[type] || []).concat([id])
                }
              }
            })
            // 每种权限分别赋值
            this.model[type] = permission[type]
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 获取角色权限菜单
    getRolePermissionList () {
      this.confirmLoading = true
      getRolePermissionList().then(res => {
        this.confirmLoading = false
        const { code, data, msg } = res
        if (code === 0) {
          this.rolePermissionList = data
          if (this.model.id) {
            // 编辑时，获取角色详情
            this.getRoleDetail()
          } else {
            // 新增时，数据权限默认选中第一项
            this.model.data = data.data[0].id
          }
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 提交
    onSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        // 效验成功
        if (valid) {
          this.confirmLoading = true
          const { model } = this
          const params = {
            id: model.id,
            show_name: model.name,
            // 拼接三种权限id，合成一个数组
            permission_ids: (model.page || []).concat(model.action || []).concat([model.data])
          }
          editRole(params).then(res => {
            this.confirmLoading = false
            const { code, data, msg, message } = res
            if (code === 0) {
              this.$message.success('操作成功')
              this.handleCancel()
              this.$emit('success')
            } else {
              this.$message.error(msg || message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.checkbox-form {
  /deep/ .ant-form-item-control-wrapper {
    // padding-top: 10px;
    .ant-checkbox-wrapper {
      margin: 0 8px 6px 0;
    }
  }
}
.modal-form-model .ant-form-item {
  margin-bottom: 0px;
}
.modal-form-model .ant-form-item:first-child {
  margin-bottom: 10px;
}
.modal-form-model .ant-checkbox-group {
  padding-top: 10px;
}
</style>